<app-validation-panel title="Requisitos para la nueva contraseña">
  <ng-container *ngFor="let context of vm.contexts()">
    <app-validation-panel-item [valid]="!context.error">
      {{ context.text }}
    </app-validation-panel-item>
  </ng-container>
</app-validation-panel>
